import { Modal, Text, DropZone, BlockStack, Button } from "@shopify/polaris";
import { useState, useCallback } from "react";
import supabase from "../../../supabase-client";

export default function UploadFilesModal({ carId, onClose, onUploaded }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleDropZoneDrop = useCallback((_dropFiles, acceptedFiles) => {
    setFiles((prev) => [...prev, ...acceptedFiles]);
  }, []);

  async function upload() {
    setUploading(true);

    for (const file of files) {
      const { error } = await supabase.storage
        .from("car-docs")
        .upload(`${carId}/${file.name}`, file, {
          upsert: true,
        });

      if (error) console.error(error);
    }

    setUploading(false);
    onUploaded();
    onClose();
  }

  return (
    <div>
      <Modal
        open
        onClose={onClose}
        title="Subir archivos"
        primaryAction={{
          content: uploading ? "Subiendo..." : "Subir",
          onAction: upload,
          loading: uploading,
          disabled: files.length === 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: onClose }]}
      >
        <Modal.Section>
          <BlockStack gap="400">
            <DropZone onDrop={handleDropZoneDrop}>
              <DropZone.FileUpload actionTitle="Subir archivos" />
            </DropZone>

            {files.length > 0 && (
              <BlockStack gap="200">
                <Text variant="headingXs">Archivos seleccionados:</Text>
                {files.map((f, i) => (
                  <Text key={i}>{f.name}</Text>
                ))}
              </BlockStack>
            )}
          </BlockStack>
        </Modal.Section>
      </Modal>
    </div>
  );
}
